module.exports = __webpack_public_path__ + "static/media/Air.0ee99b54.png";